const permissionRouter = [
    {
        path: "list-group",
        name: "permission",
        component: () => import("@/views/admin/permission"),
        default: true,
        meta: {
            model: "group",
            // requiresAuth: true,
        },
    },
    {
        path: "list-group/add",
        name: "addPermission",
        component: () => import("@/views/admin/permission/function"),
        default: true,
        meta: {
            model: "group",
            // requiresAuth: true,
        },
    },
    {
        path: "list-group/edit/:id",
        name: "editPermission",
        component: () => import("@/views/admin/permission/function"),
        default: true,
        meta: {
            model: "group",
            // requiresAuth: true,
        },
    },
    {
        path: "list-group/company/:id",
        name: "addCompanyPermission",
        component: () => import("@/views/admin/permission/components/company/index.vue"),
        default: true,
        meta: {
            model: "group_user",
            // requiresAuth: true,
        },
    },
    {
        path: "list-group/users/:id",
        name: "addUserPermission",
        component: () => import("@/views/admin/permission/components/user/index.vue"),
        default: true,
        meta: {
            model: "group_user",
            // requiresAuth: true,
        },
    }
];
export default permissionRouter;